import { useState } from "react";
import { Tab } from "types/generic";

type ModalLayoutProps = {
    tabs: Tab[];
    showTabs?: boolean;
};

const ModalLayout = ({
    tabs,
    showTabs = true,
}: ModalLayoutProps) => {
    const [selectedTab, setSelectedTab] = useState<string>(
        tabs.length > 0 ? tabs[0].id : "default"
    );

    const getSelectedTabContent = () => {
        for (let index in tabs) {
            const currentTab = tabs[index];
            if (currentTab.id === selectedTab) {
                return currentTab.content();
            }
        }
    };

    const generateTabs = () => {
        if (tabs && tabs.length > 0 && showTabs) {
            const tabList = tabs.map((tab) => {
                return (
                    <div
                        className={
                            "c-sub-header-tab" +
                            (selectedTab === tab.id ? " --active" : "")
                        }
                        onClick={() => setSelectedTab(tab.id)}
                        key={"id_" + tab.id}
                    >
                        {tab.title}
                    </div>
                );
            });
            return <div className="l-content-layout__tabs">{tabList}</div>;
        } else {
            return null;
        }
    };

    return (
        <div className="l-content-layout">
            <div className="l-content-layout-preferences__sub-header">
                {generateTabs()}
            </div>
            <div className="l-content-layout__main-content l-content-layout__main-content--modal-content">
                {getSelectedTabContent()}
            </div>
        </div>
    );
};

export default ModalLayout;
